import React, { FC } from "react";
import { faCircleSmall } from "@fortawesome/pro-solid-svg-icons/faCircleSmall";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

export const Dot: FC<
  JSX.IntrinsicAttributes & Omit<FontAwesomeIconProps, "icon">
> = (props) => <FontAwesomeIcon icon={faCircleSmall} {...props} />;
